/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2020-11-02 11:39:32
 */

import React, { useEffect } from "react";
import Main from "./containers/main";
import CheckIn from "./containers/checkIn";
import AppInfo from "./containers/appInfo";

import ModifyAppointment from "./containers/modifyAppointment";

import * as handler from "../src/components/utils/handler";

import { BrowserRouter, Switch, Route } from "react-router-dom";
import TicketCalled from "./containers/ticketCalled";
const queryString = require("query-string");

function App() {
  handler.applicationMode();
  let appRoute = window["app-config"].applicationProperties.appRoute;
  let defaultTheme =
  window["app-config"].applicationProperties.defaultTheme;
  let runApp = window["app-config"].runApp;
  let defaultLanguage = window["app-config"].defaultLang;

  useEffect(() => {
    setStyles()
    setAppLanguage()
    // setAppTitle()
  }, []);

  const setAppTitle = () => {
    // if (localStorage.getItem("lang") === "es") {
    //   language = window["localization"].es;
    // } else if (localStorage.getItem("lang") === "ar") {
    //   language = window["localization"].ar;
    // } else if (localStorage.getItem("lang") === "en") {
    //   language = window["localization"].en;
    // } else if (localStorage.getItem("lang") === "ur") {
    //   language = window["localization"].ur;
    // } else {
    //   let defaultLang = defaultLanguage;
    //   language = window["localization"][defaultLang];
    // }
    
    // console.log("APP: ", handler.setTranslations())

    
  }
  
  const setAppLanguage = () => {
    const language = queryString.parse(window.location.search).lang;
    document.title = handler.setTranslations().AppTitle;
    if (language === undefined || language === "") {
      localStorage.setItem("lang", defaultLanguage);
    } else if (language.toLowerCase() === "sp") {
      localStorage.setItem("lang", "es");
    } else {
      localStorage.setItem("lang", language);
    }

  }

  const setStyles = () => {
    const theme = queryString.parse(window.location.search).theme;
    if (theme == "dark" || defaultTheme == "dark") {
      localStorage.setItem("theme", "dark");
      import("./dark.css").then((styles) => {
        console.log("DARK THEME");
      });
    } else if (runApp.toLowerCase() === "glovo") {
      import("./assets/styles/Glovo.css").then((style) => {
        console.log("GLOVO THEME");
      });
    } else if (runApp.toLowerCase() === "leroy") {
      import("./assets/styles/Leroy.css").then((style) => {
        console.log("LEROY THEME");
      });
    } else if (runApp.toLowerCase() === "samsung") {
      import("./assets/styles/Samsung.css").then((style) => {
        console.log("SAMSUNG THEME");
      });
    } else {
      
      localStorage.setItem("theme", defaultTheme);
      import(`./${defaultTheme === "light" ? "App.css" : "dark.css"}`).then(
        (styles) => {
          console.log("DEFAULT THEME");
        }
      );
    }


  }
  
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={`/${appRoute}`} component={Main} />
        <Route exact path="/checkin/" component={CheckIn} />
        <Route exact path="/modifyappointment/" component={ModifyAppointment} />
        <Route exact path="/appinfo/" component={AppInfo} />
        <Route exact path="/details/" component={TicketCalled} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
